export enum EcosystemItemType {
  EXCHANGE = 'exchange',
  WALLET = 'wallet',
  NFT = 'nft',
  BUSINESS = 'business',
  DEVTOOL = 'devtool',
  STABLE_COIN = 'stable_coin',
  VALIDATOR = 'validator',
  WEB3_BROWSER = 'web3_browser',
}

export enum EcosystemItemTag {
  FEATURED = 'featured',
}
